import type React from "react";
import { PostCardHeaderActions } from "@/components/common/PostCardHeaderActions";

interface PostCardHeaderActionAreaProps {
  isPending: boolean;
  isFavorited?: boolean;
  isFavoriting?: boolean;
  postContentId: number;
  onToggleFavorite?: (
    postContentId: number,
    isCurrentlyFavorited: boolean,
  ) => Promise<void>;
  isFollowing?: boolean;
  notificationEnabled?: boolean;
  isFollowPending?: boolean;
  onToggleFollow?: (
    postContentId: number,
    isCurrentlyFollowing: boolean,
  ) => Promise<void>;
  onCopyLink?: () => void;
  isCurrentUserAuthor?: boolean;
  isGroupAdmin?: boolean;
  isPinned?: boolean;
  isMenuDisabled?: boolean;
  isDeleteDisabled?: boolean;
  hideOptionsButton?: boolean;
  isMinimized?: boolean;
  onToggleMinimize?: () => void;
  onReportClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onPinClick?: () => void;
  canMoveChannel?: boolean;
  onMoveChannelClick?: () => void;
}

export const PostCardHeaderActionArea: React.FC<
  PostCardHeaderActionAreaProps
> = ({ isPending, ...props }) => {
  if (isPending) {
    return null;
  }

  return (
    <div className="pointer-events-none flex items-start gap-1 opacity-0 transition-opacity duration-150 focus-within:pointer-events-auto focus-within:opacity-100 group-hover/post:pointer-events-auto group-hover/post:opacity-100">
      <PostCardHeaderActions {...props} />
    </div>
  );
};
